<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-descriptions title="" :column="7" :colon="false">
        <el-descriptions-item label="统计于：">{{exceptionObj.time}}</el-descriptions-item>
        <el-descriptions-item label="订单："><span class="c-danger">{{exceptionObj.allOrderCount}}</span>个推送失败</el-descriptions-item>
        <el-descriptions-item label="收款单："><span class="c-danger">{{exceptionObj.shoukuandanCount}}</span>个推送失败</el-descriptions-item>
        <el-descriptions-item label="付款单："><span class="c-danger">{{exceptionObj.fukuanCount}}</span>个推送失败</el-descriptions-item>
        <el-descriptions-item label="退款单："><span class="c-danger">{{exceptionObj.tuikuanCount}}</span>个推送失败</el-descriptions-item>
        <el-descriptions-item label="用户信息："><span class="c-danger">{{exceptionObj.yonghuCount}}</span>个推送失败</el-descriptions-item>
        <!-- <el-descriptions-item label=""><el-button type="primary" @click="handleQuery" size="mini">重新统计</el-button></el-descriptions-item> -->
      </el-descriptions>
    </el-card>
    <el-card class="box-card mt10">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="收款类型：">
            <el-select v-model="query.type" placeholder="请选择" clearable size="small">
              <el-option label="订单" :value="1"></el-option>
              <el-option label="充值" :value="2"></el-option>
              <el-option label="会议报名" :value="3"></el-option>
              <el-option label="升级身份" :value="4"></el-option>
              <el-option label="课程订单" :value="5"></el-option>
              <el-option label="售后补差价" :value="7"></el-option>
              <!-- <el-option label="充值送零售价" :value="8"></el-option>
              <el-option label="线下收款" :value="9"></el-option> -->
              <el-option label="使用余额支付订单" :value="102"></el-option>
              <el-option label="使用零售价支付订单" :value="103"></el-option>
              <el-option label="使用赠送账户支付订单" :value="104"></el-option>
              <el-option label="使用凭证升级赠送学费账户" :value="105"></el-option>
              <el-option label="使用凭证充值送零售价" :value="106"></el-option>
              <el-option label="使用凭证充值后入账余额账户" :value="107"></el-option>
              <el-option label="旧系统账户导入余额" :value="108"></el-option>
              <el-option label="线上充值送零售价" :value="109"></el-option>
              <el-option label="旧系统账户导入零售价" :value="110"></el-option>
              <el-option label="旧系统账户导入学费" :value="111"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="订单编号：" prop="deptName">
            <el-input v-model="query.deptName" placeholder="请输入订单编号" clearable size="small" />
          </el-form-item> -->
          <el-form-item label="订单号：">
            <el-input v-model="query.no" placeholder="请输入订单编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="推送状态：">
            <el-select v-model="query.isSuccess" placeholder="请选择" clearable size="small">
              <el-option label="推送成功" :value="1"></el-option>
              <el-option label="推送失败" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <!-- <el-button type="primary" @click="handlePush(1,'')" size="mini">批量推送</el-button> -->
            <!-- <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>
      <el-divider></el-divider>
      <el-table v-loading="listLoading" :data="list " @selection-change="selectionChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="订单类型" prop="deptName" align="center" fixed>
          <template slot-scope="{row}">
            {{orderStatus(row.dataType)}}
          </template>
        </el-table-column>
        <el-table-column label="订单单号" prop="orderNumber" align="center">
        </el-table-column>
        <el-table-column label="交易单号" prop="payResponse.newbizContent.termrefnum" align="center">
          <template slot-scope="{row}">
            {{(row.payResponse && row.payResponse.newbizContent && row.payResponse.newbizContent.termrefnum) || (row.payResponse && row.payResponse.termrefnum)}}

          </template>
        </el-table-column>
        <!-- <el-table-column label="结算方式" prop="deptName" align="center">
        </el-table-column> -->
        <el-table-column label="收款金额" prop="payMoney" align="center">
        </el-table-column>
        <!-- <el-table-column label="手机号" prop="deptName" align="center">
        </el-table-column> -->
        <el-table-column label="到账时间" prop="payTime" align="center" sortable width="200">
        </el-table-column>
        <!-- <el-table-column label="添加单据池时间" prop="operatedTime" align="center" sortable width="200">
        </el-table-column> -->
        <el-table-column label="推送成功时间" prop="sendLog.createdTime" align="center" sortable width="200">
        </el-table-column>
        <el-table-column label="推送状态" prop="deptStatus" align="center" width="150">
          <template slot-scope="{row}">
            <el-tag type="" effect="dark" v-if="row.isOk" size="mini">推送成功</el-tag>
            <el-tag type="danger" effect="dark" v-else size="mini">推送失败</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="商户单号" prop="deptName" align="center">
        </el-table-column> -->
        <!-- <el-table-column label="银行卡号" prop="deptName" align="center">
        </el-table-column> -->

        <!-- <el-table-column label="用友系统功能名称" prop="deptName" align="center" width="150">
        </el-table-column> -->
        <el-table-column label="操作" align="center" fixed="right" width="250">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">详情</el-button>
            <el-button type="text" @click="handlePush(row)">推送收款单</el-button>
            <!-- <el-button type="text" @click="handleDel(row)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <order-show ref="orderShow" @created="doQueryList({})" />
  </div>
</template>

<script>
import orderShow from './show'
import sysExternalSendLogApi from '@/api/sys/sysExternalSendLog'
import Pagination from '@/components/Pagination'
import homeStatisticsApi from '@/api/home'
import { Subtr, formatDateStr } from '@/utils/index'
import sysToolsApi from '@/api/sys/tools'
export default {
  components: {
    Pagination,
    orderShow
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      exceptionObj: {}
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    this.getException()
  },
  computed: {
    orderStatus() {
      return function (val) {
        switch (val) {
          case 1:
            return "订单";
            break;
          case 2:
            return "充值";
            break;
          case 3:
            return "会议报名";
            break;
          case 4:
            return "升级身份";
            break;
          case 5:
            return "课程订单";
            break;
          case 7:
            return "售后补差价";
            break;
          case 102:
            return "使用余额支付订单";
            break;
          case 103:
            return "使用零售价支付订单";
            break;
          case 104:
            return "使用赠送账户支付订单";
            break;
          case 105:
            return "使用凭证升级赠送学费账户";
            break;
          case 106:
            return "使用凭证充值送零售价";
            break;
          case 107:
            return "使用凭证充值后入账余额账户";
            break;
          case 108:
            return "旧系统账户导入余额";
            break;
          case 109:
            return "线上充值送零售价";
            break;
          case 110:
            return "旧系统账户导入零售价";
            break;
          case 111:
            return "旧系统账户导入学费";
            break;
          default:
            return "类型错误";
            break;
        }
      }

    }
  },
  methods: {
    getException() {
      homeStatisticsApi.getHomeException().then(res => {
        let { dinghuoCount, miaoshaCount, jifenCount } = res.data;
        let count = Subtr(Subtr(dinghuoCount, -miaoshaCount), -jifenCount)
        res.data.allOrderCount = count
        res.data.time = formatDateStr(new Date())
        this.exceptionObj = res.data;
      })
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        // canLookGoodsPrice: 1,
        // canStudyCourse: 1
      }
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({
        pageNo: 1
      })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = {
        ...this.query
      }
      this.listLoading = true
      return sysExternalSendLogApi.getShouKuanLog(query)
        .then(({ data }) => {
          data.list.forEach(item => {
            if (item.payResponse) {
              let obj = this.parsePayRequest(item.payResponse)
              item.payResponse = obj;
              item.payResponse.newbizContent = obj.bizContent ? JSON.parse(obj.bizContent) : null
            }
          })
          this.list = data.list
          this.total = data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    parsePayRequest(str) {
      const pairs = str.split(', ');
      const result = {};
      pairs.forEach(pair => {
        const [key, value] = pair.split('=');
        // 处理 miniprogramPayInfo_VSP 字段，它是一个 JSON 字符串
        if (key === "miniprogramPayInfo_VSP") {
          try {
            result[key] = JSON.parse(value);
          } catch (error) {
            result[key] = value;
          }
        } else {
          result[key] = value;
        }
      });
      return result;
    },
    // 推送
    handlePush(row) {
      sysToolsApi.sendAuxToYongYouById({ type: row.type, id: row.id, type2: 1 }).then(res => {
        let data = res.data
        if (data.state === 1) {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        } else {
          this.$common.showMsg('error', data.returnParameter)
        }

      })
    },
    // 删除
    handleDel(row) {

    },
    /**
     * 打开详情表单
     */
    handleShow(row) {
      this.$refs.orderShow.handleUpdate(row)
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-button--success.is-plain:focus,
.el-button--success.is-plain:hover {
  color: #67c23a;
  background: #f0f9eb;
  border-color: #c2e7b0;
}
::v-deep .el-divider--horizontal {
  margin-top: 0;
}
</style>
